import * as React from "react";
const SvgHome = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 28, height: 28, fill: "#FFF", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M20 7.093V2h-3v2.093zM24 13 12 1 0 13h3v10h7v-5h4v5h7V13zm-5 8h-3v-5H8v5H5V10.74l7-6.912 7 6.99z" }));
export default SvgHome;
